<template>
  <section class="yield-panel trend-panel">
    <div class="yield-title">产量预测趋势</div>
    <div ref="chartRef" class="trend-chart"></div>
  </section>
</template>

<script setup>
import * as echarts from "echarts";
import { onBeforeUnmount, onMounted, ref } from "vue";

const chartRef = ref(null);
let chartInstance = null;

const xAxisData = ["返青期", "拔节期", "抽穗期", "灌浆期", "成熟期", "当前预估"];
const seriesData = [
  {
    name: "小麦",
    color: "#50fff0",
    data: [420, 486, 528, 552, 560, 565],
  },
  {
    name: "玉米",
    color: "#ffe168",
    data: [445, 512, 566, 594, 606, 610],
  },
  {
    name: "花生",
    color: "#7cff8e",
    data: [230, 268, 302, 320, 328, 330],
  },
  {
    name: "大豆",
    color: "#ff9f6e",
    data: [126, 148, 166, 178, 183, 185],
  },
];

function resizeChart() {
  chartInstance && chartInstance.resize();
}

function hexToRgba(hex, alpha) {
  const normalized = hex.replace("#", "");
  const r = parseInt(normalized.slice(0, 2), 16);
  const g = parseInt(normalized.slice(2, 4), 16);
  const b = parseInt(normalized.slice(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

function createSeries(item) {
  return {
    name: item.name,
    type: "line",
    smooth: false,
    symbol: "circle",
    symbolSize: 10,
    data: item.data,
    lineStyle: { width: 4, color: item.color },
    itemStyle: { color: "#ffffff", borderColor: item.color, borderWidth: 3 },
    areaStyle: {
      color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
        { offset: 0, color: hexToRgba(item.color, 0.42) },
        { offset: 0.52, color: hexToRgba(item.color, 0.18) },
        { offset: 1, color: "rgba(0, 42, 39, 0.02)" },
      ]),
    },
    emphasis: { focus: "series" },
  };
}

onMounted(() => {
  chartInstance = echarts.init(chartRef.value);
  chartInstance.setOption({
    color: seriesData.map((item) => item.color),
    legend: {
      top: 8,
      right: 24,
      itemWidth: 54,
      itemHeight: 16,
      itemGap: 24,
      textStyle: {
        color: "#eafffd",
        fontSize: 26,
        fontWeight: "bold",
      },
      data: seriesData.map((item) => item.name),
    },
    grid: { top: 72, right: 42, bottom: 54, left: 66 },
    tooltip: {
      trigger: "axis",
      backgroundColor: "rgba(0, 36, 34, 0.94)",
      borderColor: "rgba(74, 255, 238, 0.56)",
      textStyle: { color: "#fff", fontSize: 24 },
      valueFormatter: (value) => `${value} 公斤/亩`,
    },
    xAxis: {
      type: "category",
      boundaryGap: false,
      data: xAxisData,
      axisTick: { show: false },
      axisLine: { lineStyle: { color: "rgba(102,255,238,.42)" } },
      axisLabel: { color: "#ffffff", fontSize: 22, fontWeight: "bold", margin: 12 },
    },
    yAxis: {
      type: "value",
      name: "公斤/亩",
      min: 0,
      max: 700,
      splitNumber: 7,
      nameTextStyle: { color: "#d7fffb", fontSize: 22, padding: [0, 0, 8, 0] },
      axisLabel: { color: "#ffffff", fontSize: 22 },
      axisTick: { show: false },
      axisLine: { show: false },
      splitLine: { lineStyle: { color: "rgba(83,255,237,.15)", type: "dashed" } },
    },
    series: seriesData.map(createSeries),
  });
  window.addEventListener("resize", resizeChart);
});

onBeforeUnmount(() => {
  window.removeEventListener("resize", resizeChart);
  chartInstance && chartInstance.dispose();
});
</script>

<style lang="less" scoped>
@import "./YieldLeftShared.less";

.trend-panel {
  padding: 20px 30px 18px;
}

.trend-chart {
  width: 100%;
  height: calc(100% - 48px);
}
</style>
